interface LabelProps {
    children: React.ReactNode;
    placeholder?: string | number;
}

const Label = ({ children, placeholder }: LabelProps) => {
    return (
        <div className="!text-gray-900 !font-sans !text-sm !font-medium !leading-5 !tracking-normal">
            <div className="text-[#0D0D17] text-sm not-italic font-medium leading-5 tracking-normal">
                <div className="w-full flex flex-nowrap row justify-between">

                    <span>{children}</span>

                    {placeholder !== undefined && placeholder !== null && (
                        <span className="text-gray-500 font-normal">
                            {placeholder}
                        </span>
                    )}

                </div>
            </div>
        </div>
    );
};

export default Label;